import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  ViewChild,
  Output,
  EventEmitter
} from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import {
  MatDialog,
  MatDialogConfig
} from "@angular/material/dialog";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { NgxSpinnerService } from "ngx-spinner";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { User } from "src/app/core/interfaces/user";
import { Utils } from "src/app/core/resources/utils";
import { AccountService } from "src/app/modules/account/account.service";
import { AdminUsersService } from "src/app/modules/administration/admin-users/admin-users.service";
import { DialogComponent } from "../dialog/dialog.component";
import { SnackBarService } from "src/app/core/services/snackBar.service";
import { DateFormatPipe } from "src/app/core/pipe/dateFormat.pipe";
import { OptionsAutocomplete } from "src/app/core/interfaces/optionsAutocomplete";
import { AmountsCargoEnum } from "src/app/core/enums/amountsCargo.enum";
import { FormMessages } from "src/app/core/messages/form-messages.enum";
import { ModalEnum } from "src/app/core/enums/modal.enum";
import { RequestTermsComponent } from "./request-terms/request-terms.component";
import { LegalTermsService } from "src/app/modules/administration/legal-terms/legal-terms.service";
import { RequestTermsDialogComponent } from "src/app/modules/administration/request-terms-dialog/request-terms-dialog.component";
import { environment } from "src/environments/environment";
import { AuthService } from "src/app/core/services/authentication.service";
import { UserManager } from "src/app/core/managers/user.manager";
@Component({
  selector: "app-input-document-user",
  templateUrl: "./input-document-user.component.html",
  styleUrls: ["./input-document-user.component.scss"],
  providers: [UserManager]
})
export class InputDocumentUserComponent implements OnInit {
  @Input() options: OptionsAutocomplete;
  @Input() inputFormControl: FormControl;
  @Input() validate: string = '';
  @Input() typeAction: string = '';
  //Output
  @Output() searchButtonClick: EventEmitter<boolean> = new EventEmitter();
  @Output() emitExistingUser: EventEmitter<User> = new EventEmitter();
  @ViewChild(MatAutocompleteTrigger)
  trigger: MatAutocompleteTrigger;
  documentInputFormControl: FormControl = new FormControl();
  searchButtonPressed: boolean = false;
  listUsers: Observable<User[]>;
  showCreateDriverOption: boolean = false;
  filteredUsers: any[] = [];
  private lastValue = '';

  constructor(
    private adminUsersService: AdminUsersService,
    public utils: Utils,
    public spinner: NgxSpinnerService,
    public snackbarservice: SnackBarService,
    public dateFormatPipe: DateFormatPipe,
    private matDialog: MatDialog,
    private termsAndConditionsService: LegalTermsService,
    private accountService: AccountService,
    private authService: AuthService,
    private userManager: UserManager
  ) {

  }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes.options && changes.options.currentValue) {
        this.setValidatorsInput();
        if (changes.options.currentValue.initialValue || changes.options.currentValue.initialValue === "") {
          if (changes.options.currentValue.initialValue === "") {
            this.showCreateDriverOption = false;
            this.searchButtonPressed = false;
            this.filteredUsers = [];
            this.documentInputFormControl.setValue('');
          } else {
            this.searchButtonPressed = true;
            this.documentInputFormControl.setValue({
              information: { document: changes.options.currentValue.initialValue }
            });
          }

        }
        if ((changes.options.currentValue.showUserName || this.typeAction === 'editDriver') && this.options.initialValue) this.searchUser();
      }

      if (changes.validate) {
        switch (this.validate) {
          case 'touched':
            this.documentInputFormControl.markAsTouched();
            break;
          case 'untouched':
            this.documentInputFormControl.markAsUntouched();
            break;
          case 'enable':
            this.documentInputFormControl.enable();
            break;
          case 'disable':
            this.documentInputFormControl.disable();
            break;
          case 'disable&untouched':
            this.documentInputFormControl.markAsUntouched();
            this.documentInputFormControl.disable();
            break;
          case 'setValidators':
            this.setValidatorsInput(true);
            break;
          case 'clearValidators':
            this.documentInputFormControl.clearValidators();
            this.documentInputFormControl.updateValueAndValidity();
            break;
          default:
            break;
        }
      }
    }
  }

  setValidatorsInput(isRequired?: boolean) {
    const validator = this.inputFormControl && this.inputFormControl.validator ? this.inputFormControl.validator({} as AbstractControl) : '';
    const maxLength = this.options && this.options.documentTypeId && this.options.documentTypeId === '3' ? AmountsCargoEnum.MAX_NIT_LENGTH : AmountsCargoEnum.MAX_DOCUMENT_LENGTH;
    if ((validator && validator.required) || isRequired) this.documentInputFormControl.setValidators([Validators.required, Validators.maxLength(maxLength), Validators.minLength(AmountsCargoEnum.MIN_DOCUMENT_LENGTH)]);
    else this.documentInputFormControl.setValidators([Validators.maxLength(maxLength), Validators.minLength(AmountsCargoEnum.MIN_DOCUMENT_LENGTH)]);
    this.updateValueInput();
    this.documentInputFormControl.updateValueAndValidity();
  }

  private updateValueInput() {
    const value = this.utils.clone(this.documentInputFormControl.value);
    const document: string = value && value.information && value.information.document ? value.information.document : value;
    if (!document) return;
    let newDocument: string = document;
    if (this.enableOnlyNumbers) newDocument = document.replace(/[^0-9]*/g, '');
    else newDocument = document.replace(/[^0-9A-Za-z]/g, '').toUpperCase();

    if (value && value.information && value.information.document) {
      value.information.document = newDocument;
      this.documentInputFormControl.setValue(value);
    } else if (value) this.documentInputFormControl.setValue(newDocument);

    const inputFormControlValue = this.utils.clone(this.inputFormControl.value);
    if (inputFormControlValue && inputFormControlValue.information && inputFormControlValue.information.document) {
      inputFormControlValue.information.document = newDocument;
      this.inputFormControl.setValue(inputFormControlValue);
    } else if (inputFormControlValue) this.inputFormControl.setValue(newDocument);
  }

  private filterUsers(value: string): Observable<User[]> {
    this.spinner.show();
    return this.adminUsersService
      .getUsersList(this.options.filterBy ? this.options.filterBy : "user", 1, 4, null, value)
      .pipe(
        map((response) => {
          this.showCreateDriverOption = true;
          this.spinner.hide();
          if (response) {
            return response;
          } else {
            return [];
          }
        })
      );
  }

  displayUserDocument(user?: User): string | undefined {
    try {
      return user ? user.information.document : "";
    } catch (e) {
      return user.toString();
    }
  }

  onSelectUser($event: MatAutocompleteSelectedEvent) {
    const selectedUser = $event.option.value;
    if (selectedUser === "createDriver") {
      this.inputFormControl.setValue(selectedUser);
      return;
    }
    const document: string = selectedUser.information.document;

    //Usuarios existentes
    if (this.options && this.options.typeUser && this.options.typeUser === "driver") {
      this.searchButtonClick.emit(true);
      this.accountService
        .validateEntity(1, document)
        .subscribe((user: User) => {
          if (user && user.information && (user.information.documentTypeId === '3' || user.information.documentTypeName === 'NIT')) {
            this.documentInputFormControl.setValue('');
            this.inputFormControl.setValue(null);
            this.filteredUsers = [];
            this.snackbarservice.openSnackBar("No es posible asignar a una empresa como conductor de un vehículo", undefined, 'error');
          } else if (!this.userManager.hasValidPolicies(user) && user && user.information && user.information.name && user.information.document && user.phone) {
            this.requestTermsToExistentUser(user);
          } else {
            this.emitValidTerms(this.options.typeUser);
            this.inputFormControl.setValue(selectedUser);
          }
        });
    } else {
      this.emitValidTerms(this.options.typeUser);
      this.inputFormControl.setValue(selectedUser);
    }
  }

  changeValue(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.searchButtonClick.emit(false);
    if (value != this.lastValue) {
      this.searchButtonPressed = false;
      if (this.inputFormControl)
        this.inputFormControl.setValue('');
      this.showCreateDriverOption = false;
      this.filteredUsers = [];
      this.lastValue = value;
    }
  }

  searchUser() {
    const input = document.getElementById('driverInput') as HTMLInputElement;
    if (!this.documentInputFormControl.value) {
      this.snackbarservice.openSnackBar(
        "Por favor digite un documento",
        undefined,
        "alert"
      );
      return;
    };
    if (this.documentInputFormControl.invalid) {
      this.snackbarservice.openSnackBar(FormMessages.GENERAL_ERROR_FIELD, undefined, 'alert');
      return;
    }
    if (!this.options.showUserName) (this.typeAction && this.typeAction !== 'editDriver') && input.focus();
    this.searchButtonPressed = true;
    const data = this.options.showUserName && this.options.initialValue ? this.options.initialValue : this.documentInputFormControl.value;
    const value =
      typeof data === "object" ? (data ? data.information.document : "") : data;
    if ((typeof data === "object" || typeof data === "string") && value.trim().length >= 1) {
      if (this.typeAction === 'editDriver') {
        // El detalle del usuario se obtiene del endpoint de detalle (user/{document}),
        // que es el único que trae las banderas RNDC. Antes se tomaba users[0] de user/list.
        this.spinner.show();
        this.adminUsersService.getUsersDetailByDocument(value).subscribe(
          (user: User) => {
            this.spinner.hide();
            this.showCreateDriverOption = true;
            if (user && user.information && (user.information.documentTypeName || user.information.documentTypeId)) {
              this.inputFormControl.setValue(user);
            }
          },
          () => { this.spinner.hide(); }
        );
        return;
      }
      this.filterUsers(value || "").subscribe(
        (users) => {
          if (users && users.length && (users[0].information.documentTypeName || users[0].information.documentTypeId) && this.typeAction && this.typeAction !== 'createVehicle') {
            switch (this.typeAction) {
              case 'createDriver':
                this.emitExistingUser.emit(users[0]);
                break;
              case 'editDriver':
                this.inputFormControl.setValue(users[0]);
                break;
            }
            return;
          }
          this.emitExistingUser.emit(users[0]);
          if (this.options.showUserName && users.length) this.documentInputFormControl.setValue(users[0])
          if (this.inputFormControl && this.documentInputFormControl.value && this.documentInputFormControl.valid && !users.length)
            this.inputFormControl.setValue(this.documentInputFormControl.value);
          this.filteredUsers = users;
          //Busqueda por conductores no registrados desde accesos distintos al cambio de conductor       
          if (!this.filteredUsers.length && this.options && !this.options.createDriver && this.options.typeUser === "driver") {
            const document: string = typeof data === "object" ? data.information.document : data;
            this.accountService
              .validateEntity(1, document)
              .subscribe((user: User) => {
                if (this.options.typeUser !== "driver" || (user && user.information && user.information.documentTypeId === '3' && user.information.documentTypeName === 'NIT')) {
                  this.emitValidTerms(this.options.typeUser);
                } else if (this.options.typeUser === "driver" && users.length === 0 && this.options.documentTypeId !== '3') {
                  if (this.options.mustAcceptTerms) {
                    this.requestTerms(document);
                  }
                } else if (!this.userManager.hasValidPolicies(user) && user && user.information && user.information.name && user.information.document && user.phone) {
                  this.requestTermsToExistentUser(user);
                } else {
                  this.emitValidTerms(this.options.typeUser);
                }
              }, (error) => { });
          }
        });
    } else {
      this.filteredUsers = [];
    }
  }

  emitValidTerms(typeUser: 'driver' | 'owner' | 'admin') {
    switch (typeUser) {
      case 'driver':
        LegalTermsService.driverHasValidTerms.next(true);
        break;
      case 'owner':
        LegalTermsService.ownerHasValidTerms.next(true);
        break;
      case 'admin':
        LegalTermsService.administratorHasValidTerms.next(true);
        break;
    }
  }


  private requestTerms(document: string) {
    switch (this.options.typeUser) {
      case 'driver':
        LegalTermsService.driverHasValidTerms.next(false);
        break;
      case 'owner':
        LegalTermsService.ownerHasValidTerms.next(false);
        break;
      case 'admin':
        LegalTermsService.administratorHasValidTerms.next(false);
        break;
    }
    const dialogConfig: MatDialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.data = {
      document,
      isDriverCreation: this.typeAction === 'createDriver'
    };
    this.matDialog
      .open(RequestTermsComponent, dialogConfig)
      .afterClosed()
      .subscribe(
        (result) => {
          this.documentInputFormControl.setValue('');
          this.inputFormControl.setValue(null);
          this.filteredUsers = [];
          if (!!result) {
            this.snackbarservice.openSnackBar('Se han enviado los términos, condiciones y políticas para su aceptación');
          }
        }
      );
  }

  private requestTermsToExistentUser(user) {
    const phone = user.phone.startsWith('57') ? user.phone.slice(2) : user.phone;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { name: user.information.name, document: user.information.document, phone, user };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    this.matDialog.open(RequestTermsDialogComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => { });
    this.filteredUsers = [];
    if (this.options.mustAcceptTerms) {
      this.documentInputFormControl.setValue('');
      this.inputFormControl.setValue(null);
    }
  }

  //GETTERS
  get documentMaxLength() {
    return this.options && this.options.documentTypeId === '3' ? AmountsCargoEnum.MAX_NIT_LENGTH : AmountsCargoEnum.MAX_DOCUMENT_LENGTH;
  }
  get documentMinLength() {
    return AmountsCargoEnum.MIN_DOCUMENT_LENGTH;
  }

  get enableOnlyNumbers() {
    return !!(this.options && this.options.documentTypeId && this.options.documentTypeId !== '2');
  }
}
